var _rect, _rect2, _rect3, _circle, _ellipse, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup87(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 67,
    viewBox: "0 0 65 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.4105,
    height: 66.1597,
    rx: 8.70523,
    fill: "url(#paint0_linear_179_179)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.6245,
    y: 66.1597,
    width: 17.4105,
    height: 66.1597,
    rx: 8.70523,
    transform: "rotate(-180 40.6245 66.1597)",
    fill: "url(#paint1_linear_179_179)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.5896,
    width: 17.4105,
    height: 66.1597,
    rx: 8.70523,
    fill: "url(#paint2_linear_179_179)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.7064,
    cy: 8.70518,
    r: 7.54453,
    fill: "url(#paint3_linear_179_179)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.9193,
    cy: 56.8741,
    rx: 7.54453,
    ry: 6.96418,
    fill: "url(#paint4_linear_179_179)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.294,
    cy: 8.70518,
    r: 7.54453,
    fill: "url(#paint5_linear_179_179)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_179_179",
    x1: 8.70523,
    y1: 0,
    x2: 8.70523,
    y2: 66.1597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#528EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7714E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_179_179",
    x1: 49.3297,
    y1: 66.1597,
    x2: 49.3297,
    y2: 132.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#528EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7714E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_179_179",
    x1: 56.2948,
    y1: 0,
    x2: 56.2948,
    y2: 66.1597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#528EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7714E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_179_179",
    x1: 8.7064,
    y1: 16.2497,
    x2: 8.7064,
    y2: 1.16064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3646DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#528EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_179_179",
    x1: 31.9193,
    y1: 63.8383,
    x2: 31.9193,
    y2: 49.9099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3646DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#528EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_179_179",
    x1: 56.294,
    y1: 16.2497,
    x2: 56.294,
    y2: 1.16064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3646DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#528EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup87);
export default __webpack_public_path__ + "static/media/Group 87.d7a66cbf08aae3277421cf5004602eb2.svg";
export { ForwardRef as ReactComponent };